<mat-card class="testimonial-card">
    <div class="carousel-inner" role="listbox">
        <div class="carousel-item active">
            <div class="testimonial4_slide flex-column">
                <img ng-if="cardData.imageUrl" class="img-circle img-responsive"  [src]="cardData.imageUrl" /><!-- [src]="cardData.imageUrl" -->
                <span class="name">{{cardData.name}}</span>
                <span class="career">{{cardData.career}}</span>
                <p>{{cardData.testimonial}}</p>
                <h4>{{cardData.university}}</h4>
                <span class="studies">{{cardData.studies}}</span>
                <span class="year">{{cardData.year}}</span>
            </div>
        </div>

    </div>
</mat-card>